import {
  GridModalFormProps,
  UseFormReturnType,
  Validator,
  globalMessageHandler,
  useForm,
} from "common";
import { useParams } from "common/components/Form/ParamsContext";
import I18n from "i18n";
import { Params } from "react-router-dom";
import {
  ReviewEmailSentItem,
  ReviewEmailSentOptions,
  getReviewEmailSentService,
} from "./reviewEmailSentApi";

export interface UseReviewEmailSentFormProps extends GridModalFormProps {}

type RouteParams = {
  review_email_sent_id?: string;
};

export interface UseReviewEmailSentFormReturnType
  extends UseFormReturnType<ReviewEmailSentItem, ReviewEmailSentOptions> {
  params?: Readonly<Params<"review_email_sent_id">>;
}

export default function useReviewEmailSentForm({
  id,
  afterSave,
  defaultValues,
}: UseReviewEmailSentFormProps): UseReviewEmailSentFormReturnType {
  const params = useParams<"review_email_sent_id">();
  const scope = {};
  const service = getReviewEmailSentService(scope);

  const form = useForm<ReviewEmailSentItem, ReviewEmailSentOptions>({
    id: params.review_email_sent_id || id,
    ignoreNavigateAfterCreate: true,
    translationCategory: "ReviewEmailSent",
    rules: {
      booking_id: Validator.rule.any().required(),
      email: Validator.rule.string().email().required(),
      sent_at: Validator.rule.any().required(),
    },
    afterSave,
    defaultValues,
    onValidationFailed: () => {
      globalMessageHandler.snack({
        severity: "error",
        message: I18n.t("App.formHasErrors"),
      });
    },
    ...service,
    loadOptions: undefined,
  });

  return { ...form, params };
}
